import Util from '@/helper/Utility.js';

export function AddCartModel() {
    this.list = [];
    this.mode = 'add';
    this.clearCart = null;

    /**
     * Add item to cart.
     * @param {string|number} campaignId
     * @param {number} qty
     */
    this.addItem = (campaignId, qty) => {
        this.list.push({
            id: campaignId,
            qty: qty
        });
    };
    /**
     * Set cart mode.
     * @param {String} mode
     */
    this.setMode = mode => {
        this.mode = mode;
    };

    /**
     * Set clearCart.
     * @param {String} mode
     */
     this.setClearCart = (isClear) => {
        this.clearCart = isClear;
    };

    /**
     * Get parameter for api.
     */
    this.getParams = () => {
        var params = {
            json: JSON.stringify(this.list),
            mode: this.mode,
            clearCart: this.clearCart
        }

        return Util.cleanObjectEmptyStr(params);
    };
}
